<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import { Tooltip } from 'bits-ui';
	import {
		POP_OUT_ALIGN,
		POP_OUT_DEFAULT_OFFSET,
		POP_OUT_SIDE,
		PORTAL_CONTAINER_SELECTOR,
		TOOLTIP_DEFAULT_DELAY_MS
	} from '$lib/constants';
	import { tv } from '../tv';
	import type { Align, Position } from '../types';

	export const tooltipProviderVariants = tv({
		base: 'pointer-events-none z-max inline-block max-h-[100vh] max-w-[100vw]'
	});

	export type TooltipTriggerProps = Record<string, unknown>;

	export interface TooltipProviderProps {
		align?: Align;
		alignOffset?: number;
		children: Snippet<[TooltipTriggerProps]>;
		delay?: number;
		offset?: number;
		position?: Position;
		tooltip: Snippet;
	}
</script>

<script lang="ts">
	let {
		align = 'Center',
		alignOffset = 0,
		children: trigger,
		delay = TOOLTIP_DEFAULT_DELAY_MS,
		offset = POP_OUT_DEFAULT_OFFSET,
		position = 'Top',
		tooltip
	}: TooltipProviderProps = $props();
</script>

<Tooltip.Provider disableHoverableContent>
	<Tooltip.Root delayDuration={delay}>
		{#snippet children({ open })}
			<Tooltip.Trigger>
				{#snippet child({ props })}
					{@render trigger(props)}
				{/snippet}
			</Tooltip.Trigger>
			{#if open}
				<Tooltip.Portal to={PORTAL_CONTAINER_SELECTOR}>
					<Tooltip.Content
						align={POP_OUT_ALIGN[align]}
						{alignOffset}
						side={POP_OUT_SIDE[position]}
						sideOffset={offset}
					>
						{#snippet child({ props, wrapperProps })}
							<div {...wrapperProps}>
								<div {...props} class={tooltipProviderVariants()}>{@render tooltip()}</div>
							</div>
						{/snippet}
					</Tooltip.Content>
				</Tooltip.Portal>
			{/if}
		{/snippet}
	</Tooltip.Root>
</Tooltip.Provider>
